import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import AssetValidationHelp from './AssetValidationHelp';

export default function Help(): React.ReactElement {
  return (
    <Switch>
      <Route path="/asset-validation" component={AssetValidationHelp} />
    </Switch>
  );
}
